import React from 'react';

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M3 18h6v-2H3v2zm0-5h12v-2H3v2zm0-7v2h18V6H3z'
			fill={fill}
			fillOpacity={fillOpacity}
		/>
	</svg>
);
